module.exports = "/_next/static/images/3aaa932432faa0c7af5391efe1dedbaa-ticket-01-02.png";